module.exports = __webpack_public_path__ + "img/NotoSansGeorgian-Medium.ecb6cbd4.svg";